import { apiRequest } from './client'

export type ProfileStorageSettings = {
  configured: boolean
  bucketName: string
  cdnRootUrl: string
  subdomainNote: string
  libraryRootPrefix: string
  enabledModuleKeys: string[]
  allowedModuleKeys: string[]
  accessKeyMasked: string
  canLeaveKeysBlank: boolean
}

export type ProfileStorageSavePayload = {
  bucketName: string
  accessKey: string
  secretKey: string
  cdnRootUrl: string
  subdomainNote: string
  libraryRootPrefix: string
  enabledModuleKeys?: string[]
}

export function getProfileStorageSettings() {
  return apiRequest<ProfileStorageSettings>('/v1/profile/storage', { method: 'GET' })
}

export function saveProfileStorageSettings(payload: ProfileStorageSavePayload) {
  return apiRequest<ProfileStorageSettings>('/v1/profile/storage', {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  })
}
